<script setup lang="tsx">
import { ElButton } from "element-plus";
import { computed, onMounted, ref } from "vue";

import { FormDefinition } from "~/api";
import { apiClient } from "~/utils/apiClient";

import getMainRouter, { applicationRouteMap } from "~/router/mainRouter";

const router = getMainRouter();

/*** for querying/filtering the listing ***/
const complianceQueryInput = ref({
  type: "",
  category: "",
  status: "",
  search: "",
});

const forms = ref<FormDefinition[]>([]);
const formsFiltered = computed(() => {
  return forms.value.filter((f) => {
    return f?.name
      .toLowerCase()
      .includes(complianceQueryInput.value.search.toLowerCase());
    // &&
    // (complianceQueryInput.type === "" ||
    //   f.Meta.Type === complianceQueryInput.type) &&
    // (complianceQueryInput.category === "" ||
    //   f.Meta.Category === complianceQueryInput.category) &&
    // (complianceQueryInput.status === "" ||
    //   f.Meta.Status === complianceQueryInput.status)
  });
});

/*** for sorting table ***/
// const sortState = ref<SortBy>({ key: 0, order: TableV2SortOrder.ASC });
// const lastState = ref<SortBy>({ key: 0, order: TableV2SortOrder.DESC });

// const onSort = (params: SortBy) => {
//   sortState.value = params;
//   sortResults();
// };

// const sortResults = () => {
//   const { key, order } = sortState.value;
//   if (key) {
//     const delta = order === TableV2SortOrder.ASC ? 1 : -1;
//     lastState.value = { key, order };
//     forms.value.sort((a, b) => {
//       return (a[key as keyof FormDefinition] ?? "") >
//         (b[key as keyof FormDefinition] ?? "")
//         ? delta
//         : -delta;
//     });
//   } else {
//     forms.value.sort((a, b) => {
//       const nameA = a.name || "";
//       const nameB = b.name || "";
//       return nameA.localeCompare(nameB);
//     });
//   }
// };

/*** calls to endpoints ***/

// THIS IS FUNCTIONAL - NEED TO CALL IN DRAWER
// /**
//  * This method calls the onDeleteForm method from the design kit, which will delete the workflow.
//  * @param workflow the workflow to delete
//  */
// const handleDeleteWorkflow = (workflow: FormDefinition) => {
//   // let cb = () => {};
//   ElMessageBox.confirm(
//     `This will permanently delete: '${workflow.name}'. Continue?`,
//     `Deleting '${workflow.name}'`,
//     {
//       confirmButtonText: "Delete",
//       cancelButtonText: "Cancel",
//       type: "warning",
//     },
//   )
//     .then(() => {
//       ElMessage.warning("WiP: Delete not implemented yet");
//     })
//     .catch(() => {
//       ElMessage({
//         type: "info",
//         message: "Delete canceled",
//       });
//     });
// };

/**
 * Creates a new workflow then redirects to the edit page
 * for that workflow.
 */
// const handleCreateWorkflow = async () => {
//   ElMessageBox.prompt(
//     "Please enter the name of this workflow:",
//     "Create New Workflow",
//     {
//       confirmButtonText: "Create",
//       cancelButtonText: "Cancel",
//     },
//   )
//     .then(async ({ value }) => {
//       await apiClient.formDefinition.createFormDefinition(value).then((res) => {
//         forms.value.push(res);
//         handleEditWorkflow(res.guid);
//       });
//     })
//     .catch(() => {
//       ElMessage({
//         type: "info",
//         message: "Canceled",
//       });
//     });
// };
const loading = ref(true);

const handleEditWorkflow = (guid: string) => {
  router.push(
    applicationRouteMap.Compliance.children.FormDesigner.path.replace(
      ":guid",
      guid,
    ),
  );
};

const handleViewWorkflowResponses = (guid: string) => {
  router.push(
    applicationRouteMap.Compliance.children.FormResponses.path.replace(
      ":guid",
      guid,
    ),
  );
};

// const tempColumns: Column<any>[] = [
//   {
//     title: "Name",
//     key: "name",
//     dataKey: "name",
//     width: 300,

//     cellRenderer: (row: any) => {
//       return (
//         <ElButton
//           text
//           onClick={() => handleEditWorkflow(row.rowData.guid)}
//           icon={Fold}
//           type="primary"
//           style="font-size: 15px;"
//         >
//           {row.rowData.name}
//         </ElButton>
//       );
//     },
//   },
//   {
//     title: "Responses",
//     key: "websiteUrl",
//     dataKey: "websiteUrl",
//     width: 300,
//     cellRenderer: (row: any) => {
//       return (
//         <ElButton
//           text
//           onClick={() => handleViewWorkflowResponses(row.rowData.guid)}
//           type="primary"
//           style="font-size: 15px;"
//         >
//           View Responses
//         </ElButton>
//       );
//     },
//   },
//   {
//     title: "Type",
//     key: "code",
//     dataKey: "code",
//     width: 200,
//   },
//   {
//     title: "Category",
//     key: "contactNumber",
//     dataKey: "contactNumber",
//     width: 200,
//   },
//   {
//     title: "Status",
//     key: "email",
//     dataKey: "email",
//     width: 200,
//   },
// ];

// const columns = computed(() =>
//   tempColumns.map((col) => {
//     return {
//       ...col,
//       sortable: true,
//     };
//   }),
// );

onMounted(async () => {
  const formDefinitions =
    await apiClient.formDefinition.getAllFormDefinitions();

  formDefinitions.sort((a, b) => {
    // sort by type then by name
    if (a.formType !== b.formType) {
      return a.formType.localeCompare(b.formType);
    }
    const nameA = a.name || "";
    const nameB = b.name || "";
    return nameA.localeCompare(nameB);
  });

  forms.value = formDefinitions;
  loading.value = false;
});
</script>

<template>
  <!-- <el-button
    class="new-button"
    size="small"
    type="primary"
    @click="handleCreateWorkflow"
  >
    New Workflow</el-button
  > -->
  <el-table
    v-loading="loading"
    :default-sort="{ prop: 'formType', order: 'ascending' }"
    :data="formsFiltered"
    style="width: 100%"
  >
    <el-table-column prop="formType" label="Type" width="360" sortable />
    <el-table-column prop="name" label="Name" width="300" sortable />
    <el-table-column label="Design">
      <template #default="scope">
        <!-- <el-button link type="primary" size="small"> Detail </el-button> -->

        <el-button
          link
          type="primary"
          size="small"
          @click="handleEditWorkflow(scope.row.guid)"
          >Edit Design
        </el-button>

        <!-- <el-button
          link
          type="danger"
          size="small"
          @click="handleDeleteWorkflow(scope.row)"
          >Delete
        </el-button> -->
      </template>
    </el-table-column>
    <el-table-column label="View">
      <template #default="scope">
        <el-button
          link
          type="primary"
          size="small"
          @click="handleViewWorkflowResponses(scope.row.guid)"
          >View Responses
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<style lang="less"></style>
